import { render, staticRenderFns } from "./PrinterTonerHistoryContent.vue?vue&type=template&id=72e7ada6&scoped=true"
import script from "./PrinterTonerHistoryContent.vue?vue&type=script&lang=js"
export * from "./PrinterTonerHistoryContent.vue?vue&type=script&lang=js"
import style0 from "./PrinterTonerHistoryContent.vue?vue&type=style&index=0&id=72e7ada6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e7ada6",
  null
  
)

export default component.exports